import { z } from 'zod';
import { EstadoSchema, IsoDateTimeSchema, ModuleCodeSchema, NullableEmailSchema, NullableUrlSchema, RoleSchema, UuidSchema, } from './common.js';
import { SessionUserSchema } from './auth.js';
export const PerfilSchema = z.object({
    id: UuidSchema,
    nombreCompleto: z.string().nullable(),
    email: NullableEmailSchema,
    rol: RoleSchema.nullable(),
    estado: EstadoSchema.nullable(),
    startupModule: ModuleCodeSchema.nullable(),
    avatarUrl: NullableUrlSchema,
    sucursalId: UuidSchema.nullable(),
    preferencias: z.record(z.string(), z.unknown()).nullable(),
    needsPasswordChange: z.boolean().nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
    updatedAt: IsoDateTimeSchema.nullable(),
});
export const UserModuleAssignmentSchema = z.object({
    id: UuidSchema,
    userId: UuidSchema,
    moduleCode: ModuleCodeSchema,
    enabled: z.boolean(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const RolePermissionEntrySchema = z.object({
    id: UuidSchema,
    roleName: RoleSchema,
    description: z.string().nullable(),
    allowedModules: z.array(ModuleCodeSchema).nullable(),
});
// Resposta de GET /api/users/me — sessão atual + módulos habilitados (RBAC).
export const MeResponseSchema = z.object({
    user: SessionUserSchema,
    enabledModules: z.array(ModuleCodeSchema),
});
//# sourceMappingURL=users.js.map